import { render, staticRenderFns } from "./bidang.vue?vue&type=template&id=469d77b4&"
import script from "./bidang.vue?vue&type=script&lang=js&"
export * from "./bidang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports